'use client';
import * as React from 'react';
import { SidebarProvider } from '@/components/ui/sidebar';
import { ReactNode } from 'react';
import HomeSidebar from '@/components/layouts/home-layout/sidebar';
import Navbar from '@/components/layouts/home-layout/navbar';
import { Footer } from '@/components/layouts/home-layout/footer';
import { useAppContext } from '@/context/app-context';
import { LoadingScreen } from '@/components/ui/loading-screen';

type Props = {
    children: ReactNode;
};

export default function HomeLayout({ children }: Props) {
    const { loading } = useAppContext();

    return (
        <SidebarProvider defaultOpen={false}>
            <div className="flex h-screen bg-neutral-850 dark w-full overflow-hidden">
                <HomeSidebar />
                <div className="flex flex-1 flex-col ">
                    <Navbar />
                    <div className="min-h-screen bg-black text-white dark overflow-x-hidden">
                        {loading ? (
                            <div className="h-screen">
                                <LoadingScreen />
                            </div>
                        ) : (
                            children
                        )}
                        <Footer />
                    </div>
                </div>
            </div>
        </SidebarProvider>
    );
}
